import AddOrders from "./AddOrders";
import AddOrdersProvider from "./AddOrdersContext";
import { ITicketOrder } from '../../../TicketDetailsContext';

interface IProps {
    searchType: string
    customerId: number
    onSelect: (selectedOrder: ITicketOrder) => void
}

let Index = ({ searchType, customerId, onSelect }: IProps) => {
    return (
        <AddOrdersProvider searchType={searchType} customerId={customerId} onSelect={onSelect}>
            <AddOrders />
        </AddOrdersProvider>
    );
}


export default Index;